module.exports = __webpack_public_path__ + "static/img/4.fd5f1b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/eng/4.png
// module id = KUiw
// module chunks = 0